import { layers, use } from 'vue-media-annotator';
import { ref } from '@vue/composition-api';

import { dummyFunction } from '@/utils';
import { Dataset, SimpleFrameData } from '@/types';

export const markChangesPending = dummyFunction;

// Extract necessary use functions
const { useTrackSelectionControls, useTrackStore, useTrackFilters } = use;

// Init track store
export const trackStore = useTrackStore({ markChangesPending });
export const {
  trackMap,
  intervalTree,
  sortedTracks,
  addTrack,
  insertTrack,
  removeTrack,
} = trackStore;

// Init track filters
export const trackFilters = useTrackFilters({
  sortedTracks: trackStore.sortedTracks,
  removeTrack: trackStore.removeTrack,
  markChangesPending,
});
export const { filteredTracks } = trackFilters;

// Init track selection controls
export const trackSelectionControls = useTrackSelectionControls({ filteredTracks });
export const {
  selectedTrackId,
  editingTrack,
  selectTrack,
} = trackSelectionControls;

export const normalVisibleModes: layers.VisibleAnnotationTypes[] = ['rectangle', 'text'];
export const visibleModes = ref(normalVisibleModes);
export function toggleVisibleMode() {
  if (visibleModes.value.length) {
    visibleModes.value = [];
  } else {
    visibleModes.value = normalVisibleModes;
  }
}

// The ref to be used in the annotator
export const imageData = ref<SimpleFrameData[] | null>(null);
export function updateImageData(dataset: Dataset | null) {
  if (dataset === null) {
    imageData.value = null;
    return;
  }

  imageData.value = dataset.map((item, index): SimpleFrameData => ({
    filename: item.reference.video_filename,
    path: item.image_path,
    index,
  }));
}
